<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     企业认证
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="fam-certify">
    <div class="main-header">
      <div class="title">
        <f-back />
        <span>{{ $route.meta.title }}</span>
      </div>
      <div class="toolbox">&nbsp;</div>
    </div>
    <el-card v-loading="loading" shadow="never" class="mb-md" :body-style="{ margin: '0px auto', 'width': '1200px' }">

      <div v-if="!applying" class="mt-lg ml mr">
        <el-form ref="authenticForm" :model="authenticForm" :rules="authenticFormRules" status-icon :hide-required-asterisk="hide" class="mt-hg ml mr" label-position="left" label-width="140px">
          <el-form-item label="营业执照" prop="license_imgurl">
            <f-image-card-uploader :files="licenseArr" :limit="1" aimPath="certify/" @change="onLicenseChange" />
          </el-form-item>
          <el-form-item label="">
            <div class="text-muted font-sm" style="line-height: 22px;margin-top: -10px;">上传营业执照图片，并加盖公章；</div>
            <div class="text-muted font-sm" style="line-height: 22px;">清晰的图片可以让您更快通过审核；</div>
            <div class="text-muted font-sm" style="line-height: 22px;">推荐上传扫描文件，拍照请尽量降低反光；</div>
            <div class="text-muted font-sm" style="line-height: 22px;">请确保营业执照图片所有信息清晰可见，内容真实有效，无任何修改；</div>
            <div class="text-muted font-sm" style="line-height: 22px;">文件大小不超过8M，格式支持 .jpg .png .pdf；</div>
            <div class="flex align-items-center" style="justify-content: flex-start;">
              <div class="text-muted font-sm" style="line-height: 22px;">新版营业执照示例图片：</div>
              <el-image :preview-src-list="srcList" :src="modelUrl" class="image small ml-xs" />
            </div>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="uni_credit_id">
            <el-popover placement="right-start" trigger="click">
              <li>可使用大写字母、数字</li>
              <li>与上传营业执照上面信息保持一致</li>
              <el-input slot="reference" v-model="authenticForm.uni_credit_id" placeholder="请填写营业执照上的统一社会信用代码" type="text" clearable>
              </el-input>
            </el-popover>
          </el-form-item>
          <el-form-item label="企业名称" prop="full_name">
            <el-input v-model="authenticForm.full_name" placeholder="请填写营业执照上的企业名称" type="text" clearable />
          </el-form-item>
          <el-form-item label="">
            <el-checkbox v-model="checked" style="color: #333;">同意鱼漾云平台读取您提交的公司信息用于企业授权认证</el-checkbox>
          </el-form-item>
        </el-form>
        <div class="bottom flex-center mt-lg">
          <el-button type="success" :disabled="!checked" @click="apply('authenticForm')">提交认证</el-button>
        </div>
      </div>

      <div v-else>
        <div class="text-center">
          <div class="font-lg">
            认证资料提交成功！
          </div>
          <el-button type="primary" class="mt-lg" @click="$router.go(-1)">返回 {{ interval - counter }}s</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { validateCode } from '@/utils/validate'
import { godCertifyApi } from '@/api/fam/famGodApi'

export default {
  name: 'FamCertify',

  components: {
    FImageCardUploader: () => import('@/components/FImageCardUploader')
  },

  data () {
    var validateCredit = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('统一社会信用代码不能为空'))
      } else {
        if (validateCode(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的统一社会信用代码'))
        }
      }
    }

    var validateLicense = (rule, value, callback) => {
      if (this.authenticForm.license_imgurl === '') {
        callback(new Error('请上传营业执照'))
      } else {
        callback()
      }
    }

    return {
      counter: 0,
      interval: 10,

      applying: false,
      hide: true,

      modelUrl: require('@/assets/license.jpg'),
      srcList: [require('@/assets/license.jpg')],
      loading: false,
      checked: false,
      authenticForm: {
        full_name: '',
        uni_credit_id: '',
        license_imgurl: ''
      },
      authenticFormRules: {
        full_name: [
          { required: true, message: '公司名称不能为空', trigger: 'blur' }
        ],
        uni_credit_id: [
          { min: 18, max: 18, message: '请输入正确的统一社会信用代码', trigger: 'blur' },
          { validator: validateCredit, trigger: 'blur' }
        ],
        license_imgurl: [
          { validator: validateLicense, trigger: 'change' }
        ]
      }
    }
  },

  computed: {
    god () {
      return this.$store.state.godStore
    },

    licenseArr () {
      const arr = []
      if (!this.authenticForm.license_imgurl) {
        return []
      }
      arr.push({
        url: this.authenticForm.license_imgurl
      })
      return arr
    }
  },

  watch: {
    counter () {
      if (this.counter >= this.interval) {
        this.$router.go(-1)
        this.counter = 0
        if (this.timer) {
          clearInterval(this.timer)
        }
      }
    }
  },

  created () {
  },

  methods: {
    onLicenseChange (Arr) {
      this.authenticForm.license_imgurl = Arr.length === 0 ? '' : Arr[0].url
    },

    apply (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          godCertifyApi(this.authenticForm).then((res) => {
            if (!res.errno) {
              this.applying = true
              this.timer = setInterval(() => {
                this.counter += 1
              }, 1000)
              this.$store.dispatch('getCustomizationInfoAction').then((resp) => {
              }).catch((err) => {
              })
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" slot-scoped>
.fam-certify {
  width: 1200px;
  margin: 0 auto;
}
</style>